import {
  ApplySchemaAttributes,
  MarkExtension,
  MarkExtensionSpec,
  MarkSpecOverride,
  extension,
} from 'remirror';

export interface PitchMarkOptions {
  className?: string;
}

const defaultOptions: Required<PitchMarkOptions> = {
  className: 'pitch-mark',
};

@extension<PitchMarkOptions>({
  defaultOptions,
  staticKeys: [],
  handlerKeys: [],
  customHandlerKeys: [],
})
export class PitchMark extends MarkExtension<PitchMarkOptions> {
  get name() {
    return 'pitch' as const;
  }

  createMarkSpec(
    extra: ApplySchemaAttributes,
    override: MarkSpecOverride
  ): MarkExtensionSpec {
    return {
      ...override,
      inclusive: false,
      excludes: 'pitch',
      attrs: {
        ...extra.defaults(),
        value: { default: '' },
      },
      parseDOM: [
        {
          tag: 'pitch',
          getAttrs: (dom: Node | string) => {
            const el = dom as Element;
            return {
              ...extra.parse(dom),
              value: el.getAttribute('value') ?? '',
            };
          },
        },
        ...(override.parseDOM ?? []),
      ],
      toDOM: node => {
        const attrs: Record<string, string | number | undefined> = {
          ...extra.dom(node),
          class: this.options.className,
          value: node.attrs.value,
        };
        return ['pitch', attrs, 0];
      },
    };
  }
}

export default PitchMark;
